export function menuTab() {
  setTimeout(() => {
    var hash = window.location.hash;
    hash = hash.replace("#", "");
    if (hash) {
      var button = document.querySelector(`[data-category="${hash}"]`);
      button.click();
    }
    // console.log("window.location.href::", window.location.href);
  }, 0);
  //
  var hikayemizButton = document.getElementById("hikayemiz-btn");

  hikayemizButton.addEventListener("click", function (e) {
    e.preventDefault();
    // console.log("çç", this.href);
    // console.log("click:", this.href);
    window.location.href = this.href;
    window.location.reload();
  });
  //
  var buttons = document.querySelectorAll("#pills-tab .nav-item .nav-link");

  buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      window.location.hash = `#${button.dataset.category}`;

      for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove("active");
        // console.log("buttons[i]", buttons[i]);
      }
      e.target.classList.add("active");
    });
  });
}
